export const API_BASE_URL = process.env.REACT_APP_API_URL;

export const ROUTES = {
  HOME_PAGE: '/home',
  LEADS_PAGE: '/leads',
  COMPANY_ENRICH_PAGE: '/company-enrich',
  EMPLOYEE_ENRICH_PAGE: '/employee-enrich',
  B2BDataOperations: '/data-operations',
  DB_CONSOLE: 'database-console',



  FILE_UPLOAD: '/file-upload',

  LOGIN: '/login',
  DASHBOARD: '/dashboard',
  SIGN_UP: '/signup',

  SETTINGS: '/settings',
  ROLE_FIELD_ASSIGNMENTS: '/role-field-assignments',
  ADD_ROLE_FIELD_ASSIGNMENT: '/add-role-field-assignment',
  USER_SIGN_UP: '/user-sign-up',
};

export const SUB_PERMISSIONS = {
  DELETE_TOKEN_DETAILS: 'delete-token-details',
  EDIT_TOKEN_DETAILS: 'edit-token-details',
};

export const TITLE = 'B2B LEAD PLATFORM';

export const AUTH_TOKEN_KEY = 'pharmacy_token';

export const DATE_FORMAT = 'YYYY-MM-DD';